module.exports = __webpack_public_path__ + "img/british-Airways.d1936fce.png";